module.exports = __webpack_public_path__ + "img/TAB_02_Active.a1bcb420.svg";